const contentType = {
  0: "xlsx",
  1: "csv",
  2: "pdf"
};
export default contentType;
